import Layout from '@layout/Index'

export const flbanner = [
  {
    path: '/flbanner',
    component: Layout,
    children: [
      {
        path: 'table',
        component: () => import('./pages/FlBannerTable.vue'),
        name: '福利社活动管理',
        meta: {
          title: '福利社活动管理',
        },
      },
      {
        path: 'form',
        component: () => import('./pages/FlBannerForm.vue'),
        name: '新增福利社',
        meta: {
          title: '新增福利社',
        },
      },
      {
        path: 'update/:id',
        component: () => import('./pages/FlBannerUpdate.vue'),
        name: '编辑福利社',
        meta: {
          title: '编辑福利社',
        },
      },
      {
        path: 'log/table/:id',
        component: () => import('./pages/FlBannerLogTable.vue'),
        name: '福利社历史记录',
        meta: {
          title: '福利社历史记录',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/flbanner/flbanner.route.js